import { AxiosInstance } from "../utils/AxiosInstance";

export const getReports = async (pagination: any, filter: string = "") => {
  const { data } = await AxiosInstance.get(`/v1/reports/?filter=${filter}`, {
    params: {
      limit: pagination.pageSize,
      offset: (pagination.current - 1) * pagination.pageSize,
    },
  });
  return data;
};

export const createReport = async (
  type: number[],
  legal_type: number,
  prospectus_email: string,
  sic_source: number = 1,
  source: number = 2,
  extra_data?: object
) => {
  let requestData = {
    type: type,
    legal_type: legal_type,
    prospectus_email: prospectus_email,
    extra_data: extra_data,
    sic_source: sic_source,
    source: source,
  };
  const { data } = await AxiosInstance.post(`/v1/reports/new`, requestData);
  return data;
};

export const activateReport = async (reportId: string) => {
  const { data } = await AxiosInstance.put(`/v1/reports/enable/${reportId}`);
  return data;
};

export const deactivateReport = async (reportId: string) => {
  const { data } = await AxiosInstance.put(`/v1/reports/disable/${reportId}`);
  return data;
};

export const downloadFile = async (reportId: string, fileType: number) => {
  return await AxiosInstance.post(
    `/v1/reports/download/${reportId}`,
    {
      file_type: fileType,
    },
    {
      responseType: "blob",
    }
  );
};

export const sendFile = async (reportId: string, fileType: number) => {
  const { data } = await AxiosInstance.post(`/v1/reports/send/${reportId}`, {
    file_type: fileType,
  });
  return data;
};

export const retryLongReport = async (reportId: string) => {
  const { data } = await AxiosInstance.get(`/v1/reports/retry/${reportId}`);
  return data;
};
